module.exports = __webpack_public_path__ + "resources/img/img_watchall_sms1_en.dbe568a3bc59fb7d7b950c93b46ce909.png";